export default __webpack_public_path__ + "static/media/woman-shoppingbag-card 2.fe12391d.png";